import React from "react";
import moment from 'moment';

function HomeCard(props) {
    // Use the matched organization passed from parent component
    const matchedOrg = props.matchedOrg;
    const organizationsLoading = props.organizationsLoading;

   {console.log("CHECK PROPS HERE",props)}


    function capitalizeFirstLetter(string) {
        return string.charAt(0).toUpperCase() + string.slice(1);
    }

    const formatPrice = (price) => {
        // Check if price is 0 or "Free" and return "Free" directly
        if (price === "0" || price === "Free") {
            return "Free";
        }

        // Convert price to string if it's a number
        let priceStr = price.toString();

        // Add '$' if it's not already present
        if (!priceStr.startsWith("$")) {
            priceStr = `$${priceStr}`;
        }

        return priceStr;
    };

    const formatTime = (time) => {
        const momentTime = moment(time, 'HH:mm:ss.SSS');
        const minutes = momentTime.minutes();
        let hours = momentTime.hours();
        const ampm = hours >= 12 ? 'pm' : 'am';
     
        // Convert 24-hour to 12-hour format 
        hours = hours % 12;
        hours = hours ? hours : 12; // If hours is 0, make it 12
     
        // Pad minutes with leading zero
        const paddedMinutes = minutes.toString().padStart(2, '0');
     
        return minutes === 0
          ? `${hours}${ampm}` // shows "6pm" when no minutes
          : `${hours}:${paddedMinutes}${ampm}`; // shows "6:30pm" when has minutes
     };


    return (
        <div className="card-home">

            <div className="img-mask">
                <img src={props.imgurl} />
            </div>



            <div className="card-home-right">
                <div className="event">
                    {props.event}
                </div>

                <div className="masjid"> 
                    {console.log("check here for masjid", matchedOrg)}
                    {organizationsLoading ? (
                        <div className="masjid">
                            <svg
                                className="home-avatar-icon"
                                viewBox="0 0 24 24"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <g>
                                    <path fill="none" d="M0 0h24v24H0z" />
                                    <path d="M12 2c5.52 0 10 4.48 10 10s-4.48 10-10 10S2 17.52 2 12 6.48 2 12 2zM6.023 15.416C7.491 17.606 9.695 19 12.16 19c2.464 0 4.669-1.393 6.136-3.584A8.968 8.968 0 0 0 12.16 13a8.968 8.968 0 0 0-6.137 2.416zM12 11a3 3 0 1 0 0-6 3 3 0 0 0 0 6z" />
                                </g>
                            </svg>
                            <p className="masjid-text">Loading...</p>
                        </div>
                    ) : matchedOrg ? (
                        <div className="masjid">
                            {matchedOrg.profilePicture ? (
                                <img
                                    className="home-avatar-icon"
                                    src={matchedOrg.profilePicture}
                                    loading="lazy"
                                    alt={`${matchedOrg.name} logo`}
                                />
                            ) : (
                                <svg
                                    className="home-avatar-icon"
                                    viewBox="0 0 24 24"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <g>
                                        <path fill="none" d="M0 0h24v24H0z" />
                                        <path d="M12 2c5.52 0 10 4.48 10 10s-4.48 10-10 10S2 17.52 2 12 6.48 2 12 2zM6.023 15.416C7.491 17.606 9.695 19 12.16 19c2.464 0 4.669-1.393 6.136-3.584A8.968 8.968 0 0 0 12.16 13a8.968 8.968 0 0 0-6.137 2.416zM12 11a3 3 0 1 0 0-6 3 3 0 0 0 0 6z" />
                                    </g>
                                </svg>
                            )}
                            <p className="masjid-text">{matchedOrg.name}</p>
                        </div>
                    ) : (
                        <div className="masjid">
                            <svg
                                className="home-avatar-icon"
                                viewBox="0 0 24 24"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <g>
                                    <path fill="none" d="M0 0h24v24H0z" />
                                    <path d="M12 2c5.52 0 10 4.48 10 10s-4.48 10-10 10S2 17.52 2 12 6.48 2 12 2zM6.023 15.416C7.491 17.606 9.695 19 12.16 19c2.464 0 4.669-1.393 6.136-3.584A8.968 8.968 0 0 0 12.16 13a8.968 8.968 0 0 0-6.137 2.416zM12 11a3 3 0 1 0 0-6 3 3 0 0 0 0 6z" />
                                </g>
                            </svg>
                            <p className="masjid-text">{props.masjid || 'Organization'}</p>
                        </div>
                    )}
                </div>

                <div className="date">
                    <p>
                        {props.date === "Mon, Jan 1 • 12 am"
                            ? `${moment(props.altdate).format('ddd, MMM D')} · ${formatTime(props.time)}`
                            : props.date
                        }
                    </p>
                </div>

                <div className="badge-grp bdgrp-evsh">
                    {props.frequency && props.frequency !== 'Once' && (
                        <div className="badge time-badge">
                            <p>{capitalizeFirstLetter(props.frequency)}</p>
                        </div>
                    )}

                    {props.age && props.age !== 'all' && (
                        <div className="badge age-badge">
                            <p>{capitalizeFirstLetter(props.age)}</p>
                        </div>
                    )}

                    {props.gender && props.gender !== ('all' || '') && (
                        <div className="badge gender-badge">
                            <p>{capitalizeFirstLetter(props.gender)}</p>
                        </div>
                    )}

                    <div className="badge price-badge">
                        <p>{formatPrice(props.price)}</p>
                    </div>

                    {props.tags && props.tags.map((tag, index) => (
                        <div key={index} className="badge tag-badge">
                            <p>{tag}</p>
                        </div>
                    ))}
                </div>
            </div>





        </div>

    )

}

export default HomeCard;